import { render } from "./BoutiqueCreer.vue?vue&type=template&id=313ed254&scoped=true&bindings={\"shared\":\"options\",\"formInfo\":\"setup\",\"route\":\"setup\",\"router\":\"setup\",\"add\":\"setup\",\"sauver\":\"setup\",\"takePhoto\":\"setup\"}"
import script from "./BoutiqueCreer.vue?vue&type=script&lang=js"
export * from "./BoutiqueCreer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-313ed254"

export default script